export Phone from './Phone';



// WEBPACK FOOTER //
// ./src/themes/components/Phone/index.js